import React, { createContext, ReactNode } from 'react';
import { MessageDescriptor } from 'react-intl';

export const CspNonceContext = createContext<string | undefined>(undefined);

export type LocaleContextValue = {
  formatMessage: (message: MessageDescriptor) => string;
  locale: string;
  updateLocale: (locale: string) => void;
};

export const LocaleContext = createContext<LocaleContextValue>({
  formatMessage: ({ id }) => id || '',
  locale: 'en',
  updateLocale: () => undefined,
});

export const NotificationsContextProvider = ({ children }: { children?: ReactNode }) => <>{children}</>;
